import * as React from "react";
import {
  Button,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel
} from "../../../components/mui";
import Modal from "../../../components/shared/Modal";
import { useToast } from "../../../components/shared/ToastProvider";

import "../../../styles/pages/rfHistoryModals.css";

/**
 * Update Condo Payment Detail Modal Component
 * Modal for updating payment information for an RF
 * Includes validation and consistent styling with other modals
 */
export default function UpdatePaymentModal({ open, onClose, rfData }) {
  const { showToast } = useToast();

  const [formData, setFormData] = React.useState({
    amountPaid: "",
    checkNo: "",
    acctEntryDate: "",
    paymentDate: "",
    checkReleased: "No"
  });

  // Check Released options
  const checkReleasedOptions = [
    { value: "Yes", label: "Yes" },
    { value: "No", label: "No" }
  ];

  // Initialize form data when modal opens
  React.useEffect(() => {
    if (open && rfData) {
      setFormData({
        amountPaid: rfData.paymentInfo?.amountPaid || "",
        checkNo: rfData.paymentInfo?.checkNo || "",
        acctEntryDate: rfData.paymentInfo?.acctEntryDate || "",
        paymentDate: rfData.paymentInfo?.paymentDate || "",
        checkReleased: rfData.paymentInfo?.checkReleased || "No"
      });
    }
  }, [open, rfData]);

  const handleChange = (field) => (event) => {
    const value = event.target.value;
    setFormData((prev) => ({
      ...prev,
      [field]: value
    }));
  };

  const handleUpdate = () => {
    // Backend developer will add API call here
    showToast({
      message: "Payment details updated successfully",
      severity: "success"
    });
    onClose();
  };

  const handleClose = () => {
    setFormData({
      amountPaid: "",
      checkNo: "",
      acctEntryDate: "",
      paymentDate: "",
      checkReleased: "No"
    });
    onClose();
  };

  const actions = (
    <>
      <Button variant="outlined" onClick={handleClose}>
        Cancel
      </Button>
      <Button variant="contained" onClick={handleUpdate}>
        Update
      </Button>
    </>
  );

  return (
    <Modal
      open={open}
      onClose={handleClose}
      title="Update Condo Payment Detail"
      actions={actions}
      maxWidth="sm"
      fullWidth
    >
      <div className="update-payment-modal-content">
        {/* Amount Paid Field */}
        <TextField
          fullWidth
          size="small"
          id="amount-paid"
          label="Amount Paid"
          type="number"
          value={formData.amountPaid}
          onChange={handleChange("amountPaid")}
          placeholder="0"
          inputProps={{ min: 0, step: "0.01" }}
        />

        {/* Check No Field */}
        <TextField
          fullWidth
          size="small"
          id="check-no"
          label="Check No"
          value={formData.checkNo}
          onChange={handleChange("checkNo")}
          placeholder="-"
        />

        {/* Acct Entry Date Field */}
        <TextField
          fullWidth
          size="small"
          id="acct-entry-date"
          label="Acct Entry Date"
          type="date"
          value={formData.acctEntryDate}
          onChange={handleChange("acctEntryDate")}
          InputLabelProps={{ shrink: true }}
        />

        {/* Payment Date Field */}
        <TextField
          fullWidth
          size="small"
          id="payment-date"
          label="Payment Date"
          type="date"
          value={formData.paymentDate}
          onChange={handleChange("paymentDate")}
          InputLabelProps={{ shrink: true }}
        />

        {/* Check Released Field */}
        <FormControl fullWidth size="small">
          <InputLabel id="check-released-label">Check Released</InputLabel>
          <Select
            labelId="check-released-label"
            id="check-released"
            label="Check Released"
            value={formData.checkReleased}
            onChange={handleChange("checkReleased")}
          >
            {checkReleasedOptions.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
    </Modal>
  );
}
